import { restClient } from 'api/rest-client';
import { DgcOrdersDto } from 'api/types/dgc/dgcOrder';
import { DgcActivationLink, DgcOrderDetailDto } from 'api/types/dgc/dgcOrderDetail';
import { TOTAL_COUNT_HEADER } from 'shared/consts/headers';
import { DgcOrdersUrlParams } from 'shared/types/dgcOrders';
import { getDgcOrdersParams } from 'shared/utils/dgcOrders';

// Header values arrive as strings (e.g. '0'), so they must be parsed before any numeric comparison.
const parseTotalCount = (value: unknown): number => {
  const parsed = Number(value);

  return Number.isFinite(parsed) && parsed >= 0 ? parsed : 0;
};

export const getDgcOrders = (urlParams: DgcOrdersUrlParams) => {
  return restClient
    .get<DgcOrdersDto>('dgc/orders', { params: getDgcOrdersParams(urlParams) })
    .then((response) => ({ orders: response.data.data, total: parseTotalCount(response.headers[TOTAL_COUNT_HEADER]) }));
};

export const getDgcOrdersForExport = (urlParams: DgcOrdersUrlParams) => {
  return restClient
    .get<DgcOrdersDto>('dgc/orders/export', { params: getDgcOrdersParams(urlParams) })
    .then((response) => ({ orders: response.data.data, total: parseTotalCount(response.headers[TOTAL_COUNT_HEADER]) }));
};

export const getDgcOrder = (uuid: string) => {
  return restClient.get<DgcOrderDetailDto>(`dgc/orders/${uuid}`).then((response) => response.data.data);
};

export const cancelDgcOrder = (uuid: string) => {
  return restClient
    .post<{ data: { status: string } }>(`dgc/orders/${uuid}/cancel`)
    .then((response) => response.data.data);
};

export const resendDgcActivationLink = (uuid: string) => {
  return restClient
    .post<{ data: DgcActivationLink }>(`dgc/card-activation-links/${uuid}/resend`)
    .then((response) => response.data.data);
};
